import React from "react";
import _ from "lodash";

import {OilTypeLegoEditor} from "../../lego/extraction-data-editors/OilTypeLegoEditor";
import ManualFeaturesLegoEditor from "./ManualFeaturesLegoEditor";
import OilQuantityLegoEditor from "../../lego/extraction-data-editors/OilQuantityLegoEditor";
import TirePressureLegoEditor from '../../lego/extraction-data-editors/TirePressureLegoEditor';


const pressureLegoSelector = {
  type: 'data',
  intentions: 'spec',
  semantics: 'PRESION_INFLADO',
  'source.type': 'owner-manual',
}

const defaultNewEmptyLego = {
  data: {},
  type: 'data',
  intentions: ['spec'],
  semantics: ['PRESION_INFLADO'],
}

export default class ManualFeaturesTirePressureEditor extends ManualFeaturesLegoEditor {
  constructor(props) {
    super(props, 'Extract Tire Pressure', 'features.hasTirePressureData', pressureLegoSelector, defaultNewEmptyLego);
    this.showRecentLegosBtn = true;
  }

  getSingleLegoDataEditor(lego, props) {
    return <TirePressureLegoEditor value={lego} {...props}/>;
  }
}
